import axios, { CancelTokenSource } from "axios"
import { DevolucionReadingDtoProps } from "./DTOs/DevolucionReadingDto"
import { DevolucionReadingFilteredDtoProps } from "./DTOs/DevolucionReadingFilteredDto"
import {
  devolucionReadingDtoAdapter,
  devolucionReadingFilteredDtoAdapter,
} from "./Devolucion.adapter"
import { DevolucionReadingFilteredDtoIPagedEnumerableProps } from "./Schemas/DevolucionReadingFilteredDtoIPagedEnumerable"
import { EntidadConciliableReadingDtoIPagedEnumerableProps } from "./Schemas/EntidadConciliableReadingDtoIPagedEnumerable"
import { entidadConciliableReadingDtoAdapter } from "./adapter_globals/EntidadConciliableReadingDto.adapter"
import { ConciliablesQueryParamsProps } from "./interfaces/ConciliablesQueryParams"
import { SortingCriteria } from "./interfaces/SortingCriteria"

export interface GetDevolucionesByFiltersParamsProps {
  FechaLowerLimit?: string
  FechaUpperLimit?: string
  ImporteLowerLimit?: number
  ImporteUpperLimit?: number
  Keyword?: string
  Remesado?: boolean
  SortingCriteria?: SortingCriteria
  IsEnabled?: boolean
  MaxResultCount?: number
  SkipCount?: number
}

// eslint-disable-next-line import/no-mutable-exports
export let devolucionesByFiltersCall: CancelTokenSource
export async function getDevolucionesByFilters(
  queryParams: GetDevolucionesByFiltersParamsProps
): Promise<DevolucionReadingFilteredDtoIPagedEnumerableProps> {
  if (typeof devolucionesByFiltersCall !== typeof undefined) {
    devolucionesByFiltersCall.cancel("Previous Request Cancelled")
  }
  devolucionesByFiltersCall = axios.CancelToken.source()
  const { data } = await axios.get("/Devolucion/by-filters", {
    params: queryParams,
    cancelToken: devolucionesByFiltersCall.token,
  })
  return {
    currentPage: data?.currentPage,
    items: data?.items.map((item: DevolucionReadingFilteredDtoProps) =>
      devolucionReadingFilteredDtoAdapter(item)
    ),
    totalCount: data?.totalCount,
  }
}

export async function getDevolucionById(
  id: string
): Promise<DevolucionReadingDtoProps> {
  const { data } = await axios.get(`/Devolucion/${id}`)
  return devolucionReadingDtoAdapter(data)
}

// eslint-disable-next-line import/no-mutable-exports
export let devolucionesConciliablesCall: CancelTokenSource
export async function getDevolucionesConciliables(
  queryParams: ConciliablesQueryParamsProps
): Promise<EntidadConciliableReadingDtoIPagedEnumerableProps> {
  if (typeof devolucionesConciliablesCall !== typeof undefined) {
    devolucionesConciliablesCall.cancel("Previous Request Cancelled")
  }
  devolucionesConciliablesCall = axios.CancelToken.source()
  const {
    data,
  }: Record<"data", EntidadConciliableReadingDtoIPagedEnumerableProps> =
    await axios.get("/Devolucion/conciliables", {
      params: queryParams,
      cancelToken: devolucionesConciliablesCall.token,
    })
  return {
    currentPage: data?.currentPage,
    items: data?.items?.map((item) =>
      entidadConciliableReadingDtoAdapter(item)
    ),
    totalCount: data?.totalCount,
  }
}
